import { NgTemplateOutlet } from '@angular/common';
import { Component, HostBinding, TemplateRef, inject } from '@angular/core';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { ToastItem, ToastService } from '@shared/services';

@Component({
  selector: 'lib-toast',
  styleUrls: ['toast.component.scss'],
  templateUrl: 'toast.component.html',
  imports: [NgbToast, NgTemplateOutlet],
})
export class ToastComponent {
  public readonly toastService = inject(ToastService);

  @HostBinding('class.ngb-toasts') public ngbToasts = true;

  public isTemplate(toast: ToastItem): toast is ToastItem & { textOrTpl: TemplateRef<unknown> } {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
